/** Height of the plot area of a reporting chart in platform size units: 88 × 4 px = 352 px. */
export const CHART_PLOT_HEIGHT = 88;
